import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const CarIcon = (props) => (
    <SvgIcon {...props}>
      <path d="M8.445,10.574h9.367v4.172c0,0.339,0.275,0.615,0.615,0.615h6.527l1.314,0.898v3.004h-0.604
        c-0.307-1.151-1.355-2.001-2.604-2.001c-1.246,0-2.295,0.85-2.602,2.001h-4.66c-0.307-1.151-1.355-2.001-2.602-2.001
        c-1.248,0-2.297,0.85-2.604,2.001H8.449c0,0-0.002-0.001-0.004-0.001c-0.338,0-0.613,0.275-0.613,0.615
        c0,0.339,0.275,0.612,0.613,0.612v0.002h2.109c0.25,1.23,1.34,2.161,2.645,2.161c1.303,0,2.393-0.931,2.643-2.161h4.578
        c0.248,1.23,1.34,2.161,2.643,2.161c1.305,0,2.395-0.931,2.645-2.161h1.178c0.338,0,0.615-0.275,0.615-0.613v-3.942
        c0-0.203-0.102-0.394-0.27-0.509l-1.633-1.117l-2.969-4.68c-0.111-0.178-0.309-0.285-0.518-0.285h-0.188h-3.496H8.445
        c-0.338,0-0.613,0.275-0.613,0.615C7.832,10.298,8.107,10.573,8.445,10.574z M13.199,21.426c-0.811,0-1.469-0.659-1.469-1.467
        c0-0.811,0.658-1.469,1.469-1.469c0.809,0,1.467,0.658,1.467,1.469C14.666,20.767,14.008,21.426,13.199,21.426z M23.062,21.426
        c-0.809,0-1.467-0.659-1.467-1.467c0-0.811,0.658-1.469,1.467-1.469c0.811,0,1.469,0.658,1.469,1.469
        C24.531,20.767,23.873,21.426,23.062,21.426z M19.041,10.574h2.557l2.395,3.559h-4.951V10.574z"/>
      <path d="M4.025,15.834v0.002h5.391v-0.002c0.338,0,0.613-0.273,0.613-0.614c0-0.338-0.275-0.612-0.613-0.612v-0.002H4.025v0.002
        c-0.338,0-0.613,0.274-0.613,0.612C3.412,15.561,3.688,15.834,4.025,15.834z"/>
      <path d="M9.164,17.414c0-0.34-0.273-0.613-0.613-0.613H5.402c-0.338,0-0.613,0.273-0.613,0.613s0.275,0.615,0.613,0.615h3.148
        C8.891,18.029,9.164,17.754,9.164,17.414z"/>
      <path d="M6.889,13.213h4.227c0.34,0,0.615-0.276,0.615-0.615s-0.275-0.613-0.615-0.613H6.889c-0.34,0-0.615,0.274-0.615,0.613
        S6.549,13.211,6.889,13.213z"/>
    </SvgIcon>
);

export default CarIcon;



// WEBPACK FOOTER //
// ./src/icons/CarIcon.jsx